import { render, staticRenderFns } from "./TraceabilityMainView.vue?vue&type=template&id=cacf142a&scoped=true"
import script from "./TraceabilityMainView.vue?vue&type=script&lang=js"
export * from "./TraceabilityMainView.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityMainView.vue?vue&type=style&index=0&id=cacf142a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacf142a",
  null
  
)

export default component.exports